import FixedFormRow from "./FixedFormRow";

const FixedFormSection = ({ section, fieldMap }) => {
  console.log("SECTION: ", section);
  return (
    <>
      {Object.entries(section).map(([rowId, fields]) => (
        <FixedFormRow
          key={rowId}
          cols={fields}
          count={fields.length}
          fieldMap={fieldMap}
        />
      ))}
    </>
  );
};

export default FixedFormSection;
